import { render, staticRenderFns } from "./readonly-text-field.component.vue?vue&type=template&id=7ad59378&scoped=true&"
import script from "./readonly-text-field.component.vue?vue&type=script&lang=ts&"
export * from "./readonly-text-field.component.vue?vue&type=script&lang=ts&"
import style0 from "./readonly-text-field.component.vue?vue&type=style&index=0&id=7ad59378&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad59378",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
